function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
import { Animation } from './Animation'; // tslint:enable:max-line-length

/**
 * @hidden
 */
// @ts-ignore

var Fade =
/** @class */
function (_super) {
  __extends(Fade, _super);

  function Fade() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */
  // @ts-ignore


  Fade.prototype.render = function (h) {
    return (// @ts-ignore
      h(Animation, {
        attrs: {
          transitionName: "fade",
          appear: this.$props.appear,
          enter: this.$props.enter,
          exit: this.$props.exit,
          transitionEnterDuration: this.$props.transitionEnterDuration,
          transitionExitDuration: this.$props.transitionExitDuration
        }
      }, [this.$slots.default])
    );
  };

  Fade = __decorate([Component({
    props: {
      appear: {
        type: Boolean,
        default: false
      },
      enter: {
        type: Boolean,
        default: true
      },
      exit: {
        type: Boolean,
        default: false
      },
      transitionEnterDuration: {
        type: Number,
        default: 500
      },
      transitionExitDuration: {
        type: Number,
        default: 500
      },
      childFactory: Object,
      className: String,
      direction: {
        type: String,
        default: 'vertical'
      },
      tag: String,
      id: String
    }
  })], Fade);
  return Fade;
}(VueComponent);

export { Fade };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-animation/dist/es/Fade.js
// module id = null
// module chunks = 